export const sendErrorLog = (payload: any) => {
    fetch("https://panel.lojistigo.com/api/log-error", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            ...payload,
            userAgent: navigator.userAgent,
            url: window.location.href,
            time: new Date().toISOString(),
        }),
    }).catch(() => { });
};
